import rtk /* , { select } */ from 'rtk';
import { createSelectorHooks } from 'rtk/react';
import { name } from './constants';
const { createSelectors } = rtk(name);

const selectors = createSelectors({
  request: (state, uuid) => state[name][uuid]?.request,
  document: (state, uuid) => state[name][uuid]?.jsonapi,
  updates: (state, uuid) => state[name][uuid]?.updates,
  pending: (state, uuid) => state[name][uuid]?.pending,
  canceled: (state, uuid) => state[name][uuid]?.canceled,
  error: (state, uuid) => state[name][uuid]?.error,
});

// RTK-AUTOEXPORT
// ---- selectors ---------
export const {
  selectRequest,
  selectDocument,
  selectUpdates,
  selectPending,
  selectCanceled,
  selectError,
} = selectors;
export const {
  useRequest,
  useDocument,
  useUpdates,
  usePending,
  useCanceled,
  useError,
} = createSelectorHooks(selectors);
